import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ShActionItemComponent } from '../../../elements/components/action-item/action-item.component';
import { ShDroppanelSelectComponent } from '../../../elements/components/droppanel-select/droppanel-select.component';
import { ShIconModule } from '../../../elements/components/icon/icon.module';

import { ShClickOutsideDirective } from '../../../elements/directives/click-outside/click-outside.directive';
import { ShFormMultiSelectComplexBaseComponent } from './base-complex/form-multi-select-complex-base.component';
import { ShFormMultiSelectBaseComponent } from './base-simple/form-multi-select-base.component';
import { ShFormMultiSelectComponent } from './main/form-multi-select.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ShIconModule,
        ShActionItemComponent,
        ShDroppanelSelectComponent,
        ShFormMultiSelectComponent,
        ShFormMultiSelectBaseComponent,
        ShFormMultiSelectComplexBaseComponent,
        ShClickOutsideDirective
    ],
    exports: [ShFormMultiSelectComponent, ShFormMultiSelectBaseComponent, ShFormMultiSelectComplexBaseComponent]
})
export class ShFormMultiSelectModule {}

export { ShFormMultiSelectComplexBaseComponent } from './base-complex/form-multi-select-complex-base.component';
export { ShFormMultiSelectBaseComponent } from './base-simple/form-multi-select-base.component';
export { ShFormMultiSelectComponent } from './main/form-multi-select.component';
